
































import Vue from "vue"

export default Vue.extend({
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    handleClickEditButton() {
      this.$emit("click-edit-button")
    },
    handleClickDeleteButton() {
      this.$emit("click-delete-button")
    },
    switchOpenFlag() {
      this.isOpen = !this.isOpen
    },
  },
})
